// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"ReportsEmptyState-primaryButton-2nDlIe","reportsEmptyStateContainer":"ReportsEmptyState-reportsEmptyStateContainer-1dYBH6"};